/*
 * Copyright (c) 2022 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

export const appConstants = {
  format: {
    dob: 'YYYY.MM.DD',
    date: 'MM/DD/YYYY',
    dbDate: 'YYYY-MM-DD',
    time: 'HH:mm',
    dateTime: 'YYYY-MM-DD HH:mm',
    dateTimeSec: 'YYYY-MM-DD HH:mm:ss.SSS'
  },
  lookup: {
    // Patient Fields
    AUTHORITIES: 'fetchAuthorities',
    PATIENT_LOCATIONS: 'fetchPatientLocations',
    GENDER: 'gender',
    CONFIDENTIALITY: 'confidentiality',

    // Exam Fields
    PATIENT_ORDERS: 'fetchPatientOrders',
    PHYSICIANS: 'fetchPhysicians',
    PRIORITIES: 'fetchPriorities',
    PROCEDURES: 'fetchProcedures',
    DEPARTMENTS: 'fetchDepartment',
    ORDERING_LOCATIONS: 'fetchOrderingLocations'
  },
  examInfo: {
    ACTION_TYPE: 'EditExam',
    PRIORITY: 'internalPriorityId',
    LABEL_PRIORITY: 'Priority',
    SCHEDULED_DATE: 'scheduledDate',
    LABEL_SCHEDULED_DATE: 'Scheduled Date',
    SCHEDULED_TIME: 'scheduledTime',
    LABEL_SCHEDULED_TIME: 'Scheduled Time',
    SCHEDULED_DATE_TIME: 'scheduledStudyDateTime',
    STUDY_DATE: 'studyDate',
    LABEL_STUDY_DATE: 'Study Date',
    STUDY_TIME: 'studyTime',
    LABEL_STUDY_TIME: 'Study Time',
    STUDY_DATE_TIME: 'studyDateTime',
    ORDER_NUMBER: 'orderNumber',
    LABEL_ORDER_NUMBER: 'Order No.',
    ACCESSION_NUMBER: 'accessionNumber',
    REFERRING_PHYSICIAN: 'internalReferringPhysicianId',
    LABEL_REFERRING_PHYSICIAN: 'Referring Physician',
    PERFORMING_PHYSICIAN: 'internalPerformingPhysicianId',
    LABEL_PERFORMING_PHYSICIAN: 'Performing Physician',
    PROCEDURE_CKEY: 'internalProcedureId',
    CLINICAL_COMMENTS: 'clinicalComments',
    LABEL_CLINICAL_COMMENTS: 'Clinical Comment',
    ORDERING_LOCATION: 'orderingLocationId',
    LABEL_ORDERING_LOCATION: 'Ordering Location',
    DEPARTMENT_NAME: 'internalDepartmentId',
    LABEL_DEPARTMENT_NAME: 'Department Name',
    PROCEDURE_DESCRIPTION: 'procedureDescription',
    PROCEDURE_CODE: 'procedureCode',
    LABEL_PROCEDURE_CODE: 'Procedure Code',
    LABEL_PROCEDURE_NAME: 'Procedure Name',
    INTERNAL_EXAM_ID: 'internalExamId'
  },
  patientInfo: {
    ACTION_TYPE: 'EditPatient',
    PATIENT_ID: 'internalPatientId',
    IDENTIFIER: 'identifier',
    AUTHORITY_CKEY: 'authorityCkey',
    DOB: 'dob',
    DATE_OF_BIRTH: 'Date of Birth',
    GENDER: 'gender',
    LABEL_GENDER: 'Sex at Birth',
    NAME: 'patientName',
    LABEL_NAME: 'Name',
    I_NAME: 'iPatName',
    LABEL_I_NAME: 'Local Name',
    PATIENT_FLAG: 'confidentialPatient',
    LABEL_PATIENT_FLAG: 'Confidentiality',
    LOCATION_ID: 'locationId',
    LOCATION_NAME: 'locationName',
    LABEL_LOCATION_NAME: 'Location Name',
    SITE_DEFAULT_LOCAL: 'SITE_DEFAULT_LOCAL'
  },
  auditLabel: {
    commentHead: 'Modified: ',
    from: ' >> from: "',
    to: '" to: "',
    end: '"; '
  },
  examStatusByStatusIdMap: {
    0: 'status.Unknown',
    10: 'status.Cancelled',
    20: 'status.Ordered',
    30: 'status.Scheduled',
    40: 'status.Arrived',
    50: 'status.Verified',
    55: 'status.ReadOffline',
    60: 'status.Dictated',
    70: 'status.Transcribed',
    90: 'status.Completed',
    100: 'status.ReferenceOnly'
  },
  appURLs: {
    // Proxy URL's
    proxyFetch: 'proxy',
    allService: 'proxy/allService',
    clinicalInfo: 'requested-procedures/{id}/clinical-info',

    // Response codes
    conflictStatus: 409,
    timeoutStatus: 504,
    unprocessableEntity: 422,
    partialStatus: 502
  },
  regEx: {
    sqlInjectionChar: /(<|%3c|&lt)script|(^')|('$)|(--)|(';)/gi,
    specialCharsForPatientId: /[<>@!#&^%,_'()\[\]{}?:|"\\\/~`=$*+]/g,
    specialChars: /[<>@!#&()\[\]{}?:;|"\\\/~`=$*+]/gi,
    beginBlankOrDigit: /^[0-9 ]/,
    beginBlankForPatientId: /^[ ]/,
    space: /^\S*$/
  }
};
